import styled from 'styled-components';

export const StyledClassifiersTab = styled('div')``;

export const StyledEditClassifiers = styled('div')`
  .ant-btn {
    margin-bottom: 24px;
  }

  .contract-classifiers-name-input {
    width: 250px;
  }

  .ql-editor {
    min-height: 200px;
  }
`;

export const StyledClassifiersButtons = styled('div')`
  display: flex;
  gap: 10px;
`;
